import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
  },
}));

const TitleSubtitle = ({ title, subtitle }) => {
  const classes = useStyles();
  return (
    <>
      <Typography className={classes.title}>{title}</Typography>
      <Typography variant={"body2"}>{subtitle}</Typography>
    </>
  );
};

export default TitleSubtitle;
